import React from 'react'
import styled, { keyframes } from 'styled-components'
import bg from '../../assets/circuit-bg.jpg';
import bot from '../../assets/circuit-bot.png';
import bubble from '../../assets/circuit-bubble.png';
import chat from '../../assets/circuit-chat.png';

const hover = keyframes`
  0% {
    transform: translate(0px,0px);
    width:15%;
      @media (max-width: 600px) {
      width:19%;
      }
  }
  50% {
    transform: translate(0px,20px);
    width:15%;
      @media (max-width: 600px) {
      width:19%;
      }
  }
  100% {
    transform: translate(0px,0px);
    width:15%;
      @media (max-width: 600px) {
      width:19%;
      }
  }

`;

const chatbubble = keyframes`
  0% {
    transform: translate(40px,-40px);
    width:5%;
    @media (max-width: 600px) {
      transform: translate(30px,-40px);
      width:6%;
      }
  }
  50% {
    transform: translate(40px,-20px);
    width:5%;
    @media (max-width: 600px) {
      transform: translate(30px,-20px);
      width:6%;
      }
  }
  100% {
    transform: translate(40px,-40px);
    width:5%;
    @media (max-width: 600px) {
      transform: translate(30px,-40px);
      width:6%;
      }
  }
   
`;
const particle01 = keyframes`
    0% {
    transform: translate(10px,50px);
    width:6%;
    opacity:0%
  }
  50% {
    transform: translate(10px,5px);
    width:5%;
    opacity:60%;
  }
  100% {
    transform: translate(10px,-60px);
    width:4%;
    opacity:0%;
  }
   
`;
   
const particle02 = keyframes`
    0% {
    transform: translate(-10px,50px);
    width:5%;
    opacity:0%
  }
  50% {
    transform: translate(-10px,5px);
    width:4%;
    opacity:60%;
  }
  100% {
    transform: translate(-10px,-60px);
    width:3%;
    opacity:0%;
  }
   
`;

const Container = styled.div`
 display: flex;
 align-items: center;
 transform-origin: center;
 align-self:center;
 justify-content: center;
 flex-direction: column;
 margin-right:15px;
 width:300px;

 z-index:1;
`
const Trendico = styled.img`
  margin-left:0px;
  justify-content:center;
   align-self:center;
  width:400px;

  position:absolute;
 z-index:1;


`;

const Bubble01 = styled.img`
  position:absolute;
  animation: ${particle01} 3s linear infinite;
   z-index:2;
`;

const Bubble02 = styled.img`
  position:absolute;
  animation: ${particle02} 3s linear infinite;
   z-index:2;
     animation-delay: 1s;
`;

const Hovering = styled.img`
  position:absolute;
  animation: ${hover} 4s ease-in-out infinite;
   z-index:2;
`;

const Chat = styled.img`
  position:absolute;
  animation: ${chatbubble} 4s ease-in-out infinite;
   z-index:2;
   animation-delay: 0.5s;
`;

const Scan = () => {
 return (
  <Container>
  <Bubble01 src={bubble}/>
  <Bubble02 src={bubble}/>
  <Chat src={chat}/>
  <Hovering src={bot}/>
  <Trendico src={bg}/>

  </Container>
 )
}

 export default Scan;